import { render, staticRenderFns } from "./AdminFileAction.vue?vue&type=template&id=37782850&"
import script from "./AdminFileAction.vue?vue&type=script&lang=js&"
export * from "./AdminFileAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports